module.exports = __webpack_public_path__ + "static/media/20110524_4522.eeb1e7b5.jpg";